import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface ErrorModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    description?: string;
}

export default function ErrorModal({
    isOpen,
    onClose,
    title = "Error Occurred",
    description = "Something went wrong while processing your request."
}: ErrorModalProps) {

    return <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent>
            <DialogHeader>
                <DialogTitle className="flex items-center gap-2 text-destructive">
                    <AlertTriangle className="w-5 h-5" />
                    {title}
                </DialogTitle>
                <DialogDescription className="pt-4" asChild>
                    <div>
                        <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-4 text-destructive">
                            <p className="font-mono text-sm">
                                {description}
                            </p>
                        </div>
                    </div>
                </DialogDescription>
            </DialogHeader>
            <div className="flex justify-end mt-4">
                <Button variant="outline" onClick={onClose}>
                    Close
                </Button>
            </div>
        </DialogContent>
    </Dialog>
}
